<template>
  <div class="row">
    <!-- eslint-disable -->
    <!-- ESLint is disabled here because we sometimes use CSS white-space properties for
      multi-line titles, thus {{ title }} needs to appear directly after the <h2> tag -->
    <h2
      :id="pageHeaderId"
      :class="{ 'text-center': centered }"
      class="cac-page__header"
    >{{ title }}
    </h2>
    <!-- eslint-enable -->
  </div>
</template>

<script>
export default {
  name: "CACPageHeader",
  // Comes from the CACPage component
  inject: ["pageHeaderId"],
  props: {
    centered: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    }
  }
};
</script>
